import React from "react";
import { CallHistory } from "../../../../Types/Dashboard.type"; // Define this type
import { H6, P } from "../../../../AbstractElements";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
interface Props {
  data: CallHistory[];
  filterText: string;
  loading: boolean;
  isLargeScreen: boolean;
}
export default function TransitionHistoryBody({
  data,
  filterText,
  loading,isLargeScreen
}: Props) {

  if (loading) {
    return (
      <tbody>
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <tr key={index} >
              <td>
                <Skeleton width={100} />
              </td>
              <td></td>
              <td>
                <Skeleton width={80} />
              </td>
              <td>
                <Skeleton width={100} />
              </td>
              <td>
                <Skeleton width={60} />
              </td>
            </tr>
          ))}
      </tbody>
    );
  }

const filtered = data.filter((item) => {
  const searchText = filterText.toLowerCase();

  return (
    item.customer?.mobile?.toLowerCase().includes(searchText) ||
    item.agent?.agent_name?.toLowerCase().includes(searchText) ||
    item.agent_amount?.toLowerCase().includes(searchText) ||
    item.call_date?.toLowerCase().includes(searchText)
  );
});

  return (
  <tbody>
  {filtered.length === 0 ? (
    <tr>
      <td colSpan={isLargeScreen ? 5 : 4} className="text-center">
        No data found
      </td>
    </tr>
  ) : (
    filtered.map((item) => {
      console.log(item,"item")
      const start = new Date(`1970-01-01T${item.start_time}`);
      const end = new Date(`1970-01-01T${item.end_time}`);
      const duration = Math.floor((end.getTime() - start.getTime()) / 60000);
      const formattedAgentAmount = item.agent_amount.endsWith('.00')
        ? item.agent_amount.slice(0, -3)
        : item.agent_amount;

      return (
        <tr role="row" key={item.id}>
          <td><H6>{item.customer?.mobile}</H6></td>
          {isLargeScreen && <td></td>}
          <td><H6>{item.agent?.agent_name}</H6></td>
          <td><H6>{item.currency}{formattedAgentAmount}</H6></td>
          <td>
            <H6 className={`text-center rounded px-2 py-1 ${
              duration < 15
                ? "bg-light-success border-light-success text-success"
                : duration < 30
                ? "bg-light-warning border-light-warning text-warning"
                : duration < 60
                ? "bg-light-primary border-light-primary text-primary"
                : "bg-light-danger border-light-danger text-danger"
            }`}>
              {item.duration} 
            </H6>
          </td>
        </tr>
      );
    })
  )}
</tbody>

  );
}
// import React from 'react'
// import { Link } from 'react-router-dom'
// import { transitionHistoryData } from '../../../../Data/Dashboard/Default'
// import { Btn, H6, Image, P } from '../../../../AbstractElements'
// import { dynamicImage } from '../../../../Utils'
// import { TransitionHistoryBodyProps } from '../../../../Types/Dashboard.type'

// export default function TransitionHistoryBody({filterText}: TransitionHistoryBodyProps) {
//     const filteredItems = transitionHistoryData.filter(
//         (item) => {
//             return Object.values(item).some((value) =>
//                 value && value.toString().toLowerCase().includes(filterText.toLowerCase())
//             );
//         }
//     );
//     return (
//         <tbody>
//             {filteredItems.map((item) => (
//                 <tr role='row' key={item.id}>
//                     <td>
//                         <div className="d-flex align-items-center gap-3">
//                             <div className="flex-shrink-0">
//                                 <Image src={dynamicImage(`dashboard-1/icon/${item.image}`)} alt="" />
//                             </div>
//                             <div className="flex-grow-1">
//                                 <Link to={`${process.env.PUBLIC_URL}/ecommerce/product_page`}>
//                                     <H6>{item.name}</H6>
//                                 </Link>
//                                 <P>{item.text}</P>
//                             </div>
//                         </div>
//                     </td>
//                     <td>{item.invoice}</td>
//                     <td className={`text-${item.color}`}>{item.amount}</td>
//                     <td>
//                         <div className="d-flex">
//                             <div className="flex-grow-1">
//                                 <H6>{item.date}</H6>
//                                 <P>{item.time}</P>
//                             </div>
//                         </div>
//                     </td>
//                     <td className="text-end">
//                         <Btn color='transparent' className={`bg-light-${item.color} border-light-${item.color} text-${item.color}`}>
//                             {item.status}
//                         </Btn>
//                     </td>
//                 </tr>
//             ))}
//         </tbody>
//     )
// }
